import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LL_H_C, LL_V_L, SimpleListAdapter, TS_DropDown, TS_Input } from '@nu-art/thunderstorm-frontend/index';
import { compare, exists, Filter, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { ModuleFE_Expression, ModuleFE_Tag, ModuleFE_Variable } from '../../../../_entity.js';
import { VariableWrapper } from '../../../../wrappers/index.js';
import { ExpressionType_Deduction, ExpressionType_InRange, ExpressionType_NormalRange, ExpressionType_ResolutionFunction } from '@app/hcs-shared/expression';
import { variableType_Attribute } from '@app/hcs-shared/core';
export class DropDown_ExpressionLeftHand extends TS_EditableItemComponent {
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        const expressionAssociationMap = ModuleFE_Expression.cache.all().reduce((map, exp) => {
            if (exp.associatedVar)
                map[exp.associatedVar] = exp;
            return map;
        }, {});
        if (!state.values) {
            //Gather variables
            const filteredExpressionTypes = [ExpressionType_ResolutionFunction.dbKey,
                ExpressionType_NormalRange.dbKey,
                ExpressionType_InRange.dbKey,
                ExpressionType_Deduction.dbKey];
            const allVars = ModuleFE_Variable.cache.filter(item => {
                if (item.type === variableType_Attribute)
                    return false;
                const associatedExpression = expressionAssociationMap[item._id];
                return !(associatedExpression && !filteredExpressionTypes.includes(associatedExpression.expressionType));
            });
            //Gather expressions
            const allGeneralExpressions = ModuleFE_Expression.cache.filter(item => !filteredExpressionTypes.includes(item.expressionType));
            //Combine and filter values for dropdown
            const allValues = [...allVars, ...allGeneralExpressions];
            if (nextProps.queryFilter)
                state.values = allValues.filter(nextProps.queryFilter);
            else
                state.values = allValues;
        }
        if (nextProps.sortBy)
            state.values = sortArray(state.values, nextProps.sortBy[0]);
        state.selectedTitle = this.getTitle(nextProps.selected);
        return state;
    }
    /**
     * Generate dropdown label from the selected values
     * @param selected the latest selected value coming from props
     * @private
     */
    getTitle(selected) {
        if (!selected)
            return;
        if (selected.type === 'atom')
            return `A${selected.id}`;
        let base;
        if (selected.type === 'expression') {
            const expression = ModuleFE_Expression.cache.unique(selected.id);
            base = expression?.label ?? 'Entity Deleted';
        }
        else {
            const variable = ModuleFE_Variable.cache.unique(selected.id);
            base = variable?.name ?? 'Entity Deleted';
        }
        return _jsx("div", { className: 'ts-dropdown__selected', style: { color: base === 'Entity Deleted' ? 'red' : '#4f4f4f' }, children: base });
    }
    isValueAtom = (value) => {
        if (!value.item)
            return false;
        return 'leftHand' in value.item;
    };
    handleSelection = async (value) => {
        if (!value) {
            return;
        }
        let leftHand = {};
        if (this.isValueAtom(value)) {
            const id = this.props.atoms.findIndex(atom => compare(value.item, atom)) + 1;
            leftHand = { id: String(id), type: 'atom' };
        }
        else {
            // If the item is from type expression (embedded expression)
            if ('label' in value)
                leftHand = { id: value._id, type: 'expression' };
            // If the user picked variable
            else
                leftHand = { id: value._id, type: 'variable' };
        }
        const cases = this.state.editable.item.cases ?? [];
        cases[this.props.index] = {
            caseOperator: undefined,
            rightHand: undefined
        };
        await this.state.editable.updateObj({
            leftHand: leftHand,
            cases: cases
        });
        this.forceUpdate();
    };
    resolveTagTitle = (value) => {
        if (!value)
            return;
        if (('valueId' in value))
            return 'HV';
        return 'Ex';
    };
    resolveSelectedItem = () => {
        if (this.props.selected.type === 'atom')
            return;
        if (this.props.selected.type !== 'expression') {
            const variable = ModuleFE_Variable.cache.unique(this.props.selected.id);
            if (!variable)
                throw new MUSTNeverHappenException(`variable with id ${this.props.selected.id} not found`);
            return variable;
        }
        const expression = ModuleFE_Expression.cache.unique(this.props.selected.id);
        if (!expression)
            throw new MUSTNeverHappenException(`expression with id ${this.props.selected.id} not found`);
        return expression;
    };
    getTagsByItem = (item) => {
        if (!item)
            return;
        const type = this.resolveTagTitle(item);
        // get tagIds for Expressions
        const tags = type === 'Ex' ? ModuleFE_Tag.getOnlyChildrenIdsByTagIds(item?._tagIds) : [];
        return tags.length > 0 && _jsx(LL_V_L, { children: tags.map(tag => _jsx("div", { className: 'lefthand-tags', children: tag.label })) });
    };
    renderSelectedItem = () => {
        const selectedTitle = this.state.selectedTitle;
        if (!selectedTitle)
            return _jsx("div", { className: "ts-dropdown__placeholder", children: 'Pick A Variable' });
        const selectedItem = this.resolveSelectedItem();
        const type = this.resolveTagTitle(selectedItem);
        return _jsxs(LL_H_C, { style: { gap: '5px' }, className: 'ts-dropdown__selected', children: [selectedTitle, _jsx(LL_H_C, { style: { gap: '2px' }, children: selectedItem && _jsx("div", { className: 'lefthand-type-tag', children: type }) })] });
    };
    renderSearchInput = (dropDown) => {
        return _jsxs("div", { className: 'input-with-label', children: [_jsx(TS_Input, { type: "text", value: dropDown.props.inputValue, 
                    // @ts-ignore
                    onChange: (filterText) => dropDown.reDeriveState({ filterText }), focus: true, style: { width: '100%' }, placeholder: dropDown.props.placeholder || '', onCancel: () => {
                        // @ts-ignore
                        dropDown.reDeriveState({ open: false, filterText: undefined });
                    }, onKeyDown: (e) => {
                        // @ts-ignore
                        dropDown.inputKeyEventHandler(e);
                    } }), this.state.selectedTitle] });
    };
    render() {
        const items = this.state.values;
        const filter = new Filter(i => {
            if (!i)
                return [];
            if (ModuleFE_Variable.cache.unique(i._id))
                return new VariableWrapper(i).getSearchableText();
            return [i.label ?? ''];
        });
        let adapter = () => SimpleListAdapter(items, i => {
            return _jsxs(LL_H_C, { className: 'variable-dropdown-row', children: [i.item?.name ?? i.item.label, _jsxs(LL_H_C, { className: 'variable-tags', children: [this.getTagsByItem(i.item), _jsx("div", { className: 'lefthand-type-tag', children: this.resolveTagTitle(i.item) })] })] });
        });
        if (exists(this.props.atoms)) {
            const items = this.props.atoms?.map((atom, index) => ({ label: `A${index + 1}`, item: atom }));
            adapter = () => SimpleListAdapter(items, item => {
                return _jsx(_Fragment, { children: item.item.label });
            });
        }
        const leftHandProps = {
            adapter,
            selectedItemRenderer: this.renderSelectedItem,
            renderSearch: this.renderSearchInput,
            limitItems: this.props.limitItems ?? 20,
            caret: this.props.disabled ? undefined : DropDown_DefaultCaret,
            className: 'variable-dropdown',
            filter: filter
        };
        const DropDown_LeftHand = TS_DropDown.prepareEditable(leftHandProps);
        return DropDown_LeftHand({
            editable: this.state.editable,
            prop: 'leftHand',
            disabled: this.props.disabled,
            onSelected: this.handleSelection,
            showErrorTooltip: true
        });
    }
}
//# sourceMappingURL=app-dropdowns.js.map